import { SLICE_NAME } from 'constants/common';
import React from 'react';
import { useSelector } from 'react-redux';
import './layout.css';
import { THEME_KEY } from 'constants/theme';
import { getBackgroundSystemUrl } from 'utils/functions';

const BackgroundSystem = ({ backgroundUrl, blur }) => {
    const inital = useSelector((state) => state[SLICE_NAME.THEME].initialConfig);
    const initalBackground = inital ? inital[THEME_KEY.BACKGROUND] : '';
    const initalBlur = inital ? inital[THEME_KEY.BLUR] : 1;
    const background = backgroundUrl !== undefined ? backgroundUrl : initalBackground;
    const backgroundBlur = blur !== undefined ? blur : initalBlur;

    const bgcolor = background === -1;

    const bgUrl = `url("${getBackgroundSystemUrl(background)}")`;

    return (
        <div
            className="backgroundSystem"
            style={{
                backgroundImage: bgUrl,
                opacity: backgroundBlur,
                backgroundColor: `${bgcolor ? 'unset' : '#FFF'}`,
            }}
        ></div>
    );
};

export default BackgroundSystem;
